import React, { FC, useEffect, useState } from 'react'
import './BankUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import banks from 'ng-banks'
import Swal from 'sweetalert2'
import profileService from 'Services/profileService'

interface propsType {
  toggleModal: () => void
  profile: any
  setProfile: any
}

export type bankUpdate = {
  bankName: string
  bankAccountNumber: string
}

const schema = yup.object().shape({
  bankName: yup.string().required('Field is required'),
  bankAccountNumber: yup.string().required('Field is required'),
})

const BankUpdate: FC<propsType> = ({ toggleModal, profile, setProfile }) => {
  const bankList = banks.getBanks()

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<bankUpdate>({
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    if (profile) {
      reset({
        bankName:
          profile?.bankName === null || profile?.bankName === 'string' ? '' : profile?.bankName,
        bankAccountNumber:
          profile?.bankAccountNumber === null || profile?.bankAccountNumber === 'string'
            ? ''
            : profile?.bankAccountNumber,
      })
    }
  }, [profile, reset])

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  const submitNewUserInformation = handleSubmit(async (data: bankUpdate) => {
    await profileService
      .updateProfileV2({
        bankName: data.bankName,
        bankAccountNumber: data.bankAccountNumber,
      })
      .then(
        (res: any) => {
          setRequest(false)
          Swal.fire({
            text: 'Employment information update request sent succesfully',
            icon: 'success',
            confirmButtonText: 'Ok',
          })
          if (res.data.status === true) {
            setProfile((prev: any) => ({
              ...prev,
              ...data,
            }))
          } else {
            const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                cancelButton: 'btn btn-danger',
              },
              buttonsStyling: false,
            })

            swalWithBootstrapButtons.fire({
              title: 'Oops!',
              text: 'Something went wrong!',
              icon: 'warning',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'close',
              reverseButtons: true,
            })
          }

          toggleModal()
        },
        (error: { response: { data: { error: string } } }) => {
          console.log(error)
          setRequest(false)
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
          })

          swalWithBootstrapButtons.fire({
            title: 'Oops!',
            text: error.response.data.error,
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'close',
            reverseButtons: true,
          })
        },
      )
  })
  return (
    <div className='bank-update'>
      <form>
        <div className='form-group mb-3'>
          <label htmlFor='bank'>Bank</label>

          <select id='bank' className='form-control' {...register('bankName')}>
            <option disabled value=''>
              --Select Bank--
            </option>

            {bankList.map((bank: any) => (
              <option key={bank.code} value={bank.name}>
                {bank.name}
              </option>
            ))}
          </select>

          {errors.bankName && <div className='text-danger'>{errors.bankName.message}</div>}
        </div>

        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>Account Number</label>
          <input
            placeholder='Account Number'
            type='text'
            id='bankAccountNumber'
            className='form-control'
            {...register('bankAccountNumber')}
          />
          {errors.bankAccountNumber && (
            <div className='text-danger'>{errors.bankAccountNumber.message}</div>
          )}
        </div>

        <div className='form-group'>
          <button
            className='btn btn-default-2 w-100'
            onClick={(e) => submitNewUserInformation(e)}
            disabled={request}
          >
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default BankUpdate
